import { createReducer, on } from '@ngrx/store';

import { ActionStateCreator, IActionState } from '../../utils';
import * as fromActions from './homepage-module.actions';

export interface IHomepageModelState {
  tokenActionState: IActionState;
  token: string;
}

export const initialState: IHomepageModelState = {
  tokenActionState: ActionStateCreator.create(),
  token: null,
};

export const hompageModuleReducer = createReducer(
  initialState,

  on(fromActions.GetHomepageModuleToken, state => {
    return {
      ...state,
      token: null,
      tokenActionState: ActionStateCreator.onStart(),
    };
  }),
  on(fromActions.GetHomepageModuleTokenSuccess, (state, { token }) => {
    return {
      ...state,
      tokenActionState: ActionStateCreator.onSuccess(),
      token,
    };
  }),
  on(fromActions.GetHomepageModuleTokenFailed, (state, { error }) => {
    return {
      ...state,

      tokenActionState: ActionStateCreator.onError(error),
    };
  })
);

export const getHomepageModuleTokenActionState = (state: IHomepageModelState) =>
  state.tokenActionState;

export const getHomepageModuleToken = (state: IHomepageModelState) => state.token;
